import { Component, Input, OnInit } from '@angular/core';


@Component({
    selector: 'nope-panel',
    template: `<div class="panel panel-default" style="margin-top: 1em; padding: 1em;">
    <div class="panel-body" style="text-align: center;">
        <h1 class="text-{{textStyle}}" style="margin: 0 0 2em 0;">{{ title | translate }}</h1>
        <p class="text-{{textStyle}}" style="font-size: 96px;">
            <i class="glyphicon {{glyphName}}"></i>
        </p>
        <h3 class="text-{{textStyle}}">{{ message | translate }}</h3>
    </div>
</div>`
})
export class NopePanelComponent implements OnInit {

    @Input() title: string = 'Not Allowed';
    @Input() glyphName: string = 'glyphicon-off';
    @Input() message: string = '';
    @Input() textStyle: string = 'muted';

    constructor() {}
    
    ngOnInit() {}

}